var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as contactSelectors from "../../redux/contact/contact.selectors";
import { ELocale } from "../../types/i18n.types";
import { isBrusselsZip, isFlemishZip } from "../../utils/property.utils";
import { getStore } from "../../utils/redux/redux.utils";
import { getPagedId as getPagedIdBase, } from "../generic/paged.utils";
import { ETemplateAccessScope, ETemplateRegionBelgium, } from "./template.types";
export var getPagedId = function (params) {
    return getPagedIdBase(__assign(__assign({}, params), { entityName: "template" }));
};
export var getRegionByZip = function (zip) {
    if (isBrusselsZip(zip)) {
        return ETemplateRegionBelgium.Brussels;
    }
    if (isFlemishZip(zip)) {
        return ETemplateRegionBelgium.Flanders;
    }
    return ETemplateRegionBelgium.Wallonia;
};
var getTenantContact = function (id) {
    if (!id) {
        return;
    }
    var store = getStore();
    if (!store) {
        return;
    }
    var contactForMember = contactSelectors.getContact(store.getState(), undefined, id);
    if (!contactForMember) {
        return;
    }
    return contactForMember;
};
var matchesLocaleOrEmpty = function (templateLocale, desired) {
    return !templateLocale || templateLocale === desired;
};
export var sortTemplatesByRegionAndLocale = function (_a) {
    var templates = _a.templates, property = _a.property, tenantId = _a.tenantId;
    var privateTemplates = templates.filter(function (template) { return template.accessScope === ETemplateAccessScope.Private; });
    var publicTemplates = templates.filter(function (template) { return template.accessScope !== ETemplateAccessScope.Private; });
    if (!(property === null || property === void 0 ? void 0 : property.zip))
        return __spreadArray(__spreadArray([], privateTemplates, true), publicTemplates, true);
    var region = getRegionByZip(property.zip);
    var tenantContact = getTenantContact(tenantId);
    var filteredPublicTemplates;
    var filteredPrivateTemplates;
    switch (region) {
        case ETemplateRegionBelgium.Flanders:
            filteredPublicTemplates = publicTemplates.filter(function (template) {
                return template.region === ETemplateRegionBelgium.Flanders &&
                    matchesLocaleOrEmpty(template.locale, ELocale.NL);
            });
            filteredPrivateTemplates = privateTemplates.filter(function (template) {
                return template.region === ETemplateRegionBelgium.Flanders &&
                    matchesLocaleOrEmpty(template.locale, ELocale.NL);
            });
            break;
        case ETemplateRegionBelgium.Wallonia:
            filteredPublicTemplates = publicTemplates.filter(function (template) {
                return template.region === ETemplateRegionBelgium.Wallonia &&
                    matchesLocaleOrEmpty(template.locale, ELocale.FR);
            });
            filteredPrivateTemplates = privateTemplates.filter(function (template) {
                return template.region === ETemplateRegionBelgium.Wallonia &&
                    matchesLocaleOrEmpty(template.locale, ELocale.FR);
            });
            break;
        default:
            filteredPublicTemplates = publicTemplates.filter(function (template) {
                if (!tenantContact || !template.locale) {
                    return template.region === ETemplateRegionBelgium.Brussels;
                }
                return (template.region === ETemplateRegionBelgium.Brussels &&
                    template.locale === tenantContact.locale);
            });
            filteredPrivateTemplates = privateTemplates.filter(function (template) {
                if (!tenantContact || !template.locale) {
                    return template.region === ETemplateRegionBelgium.Brussels;
                }
                return (template.region === ETemplateRegionBelgium.Brussels &&
                    template.locale === tenantContact.locale);
            });
            break;
    }
    return __spreadArray(__spreadArray([], filteredPrivateTemplates, true), filteredPublicTemplates, true);
};
